<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="text-wrapper_1 flex-col">
        <span class="text_2">用户注册</span>
      </div>
      <div class="group_3 flex-col"><div class="box_1 flex-col"></div></div>
      <!-- <div class="group_4 flex-row"> -->
        <!-- <div class="image-text_1 flex-row justify-between">
          <div class="section_1 flex-col">
            <div class="group_5 flex-col"></div>
          </div>
          <span class="text-group_1">欢迎注册实习梦工账号</span>
        </div> -->
      <!-- </div> -->
      
      <!-- 用户名输入框 -->
      <div class="text-wrapper_2 flex-col">
        <van-field
          v-model="username"
          class="input-field"
          placeholder="用户名"
          clearable
          @keyup.enter="register"
        />
      </div>
    </div>
    
    <div class="group_6 flex-col">
      <!-- 密码输入框 -->
      <div class="text-wrapper_3 flex-col">
        <van-field
          v-model="password"
          class="input-field"
          type="password"
          placeholder="密码"
          clearable
          @keyup.enter="register"
        />
      </div>
      
      <!-- 确认密码输入框 -->
      <div class="text-wrapper_4 flex-col">
        <van-field
          v-model="confirmPassword"
          class="input-field"
          type="password"
          placeholder="确认密码"
          clearable
          @keyup.enter="register"
        />
      </div>
      
      <!-- 邮箱输入框 -->
      <div class="text-wrapper_5 flex-col">
        <van-field
          v-model="email"
          class="input-field"
          type="email"
          placeholder="邮箱地址"
          clearable
          @keyup.enter="register"
        />
      </div>
      
      <!-- 注册按钮 -->
      <div class="text-wrapper_6 flex-col" @click="register">
        <span class="text_5" v-if="!loading">注册</span>
        <span class="text_5" v-else>注册中...</span>
      </div>
      
      <span class="text_6" @click="goToLogin">已有账号？立即登录</span>
      
      <div class="group_7 flex-row justify-between">
        <div class="box_2 flex-col" @click="toggleAgreement">
          <div class="box_3 flex-col" v-if="agreeTerms"></div>
        </div>
        <span class="text_7">注册即代表您同意《用户协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Field } from 'vant'
import CryptoJS from 'crypto-js'
import { API_ENDPOINTS } from '@/config/api'

export default {
  name: 'UserRegister',
  components: {
    'van-field': Field
  },
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      email: '',
      loading: false,
      agreeTerms: true
    };
  },
  methods: {
    async register() {
      // 表单验证
      if (!this.validateForm()) {
        return;
      }
      
      this.loading = true;
      try {
        // 对密码进行MD5加密
        const encryptedPassword = CryptoJS.MD5(this.password).toString();
        
        const res = await axios.post(API_ENDPOINTS.AUTH.REGISTER, {
          username: this.username,
          password: encryptedPassword,
          email: this.email,
          captcha: ''
        });
        
        if (res.data.code === 0) {
          const token = res.data.data.accessToken;
          if (token) {
            localStorage.setItem('token', token);
            this.showToastMsg('注册成功');
            // 延迟跳转，让用户看到成功提示
            setTimeout(() => {
              this.$router.push('/shouye');
            }, 1000);
          } else {
            this.showToastMsg('注册失败：未获取到token');
          }
        } else {
          // 根据错误码显示不同的错误信息
          let errorMsg = '注册失败';
          switch (res.data.code) {
            case 40001:
              if (res.data.message.includes('中文')) {
                errorMsg = '用户名不能包含中文';
              } else {
                errorMsg = '用户已存在';
              }
              break;
            case 40002:
              errorMsg = '注册失败，请重试';
              break;
            default:
              errorMsg = res.data.message || '注册失败';
          }
          this.showToastMsg(errorMsg);
        }
      } catch (error) {
        console.error('注册失败:', error);
        if (error.response) {
          this.showToastMsg(`网络错误: ${error.response.status}`);
        } else if (error.request) {
          this.showToastMsg('网络连接失败，请检查网络');
        } else {
          this.showToastMsg('注册失败，请重试');
        }
      } finally {
        this.loading = false;
      }
    },
    
    validateForm() {
      if (!this.username.trim()) {
        this.showToastMsg('请输入用户名');
        return false;
      }
      
      if (this.username.length < 3) {
        this.showToastMsg('用户名长度不能少于3位');
        return false;
      }
      
      // 检查用户名是否包含中文
      const chineseRegex = /[\u4e00-\u9fa5]/;
      if (chineseRegex.test(this.username)) {
        this.showToastMsg('用户名不能包含中文');
        return false;
      }
      
      if (!this.password) {
        this.showToastMsg('请输入密码');
        return false;
      }
      
      if (this.password.length < 6) {
        this.showToastMsg('密码长度不能少于6位');
        return false;
      }
      
      if (!this.confirmPassword) {
        this.showToastMsg('请确认密码');
        return false;
      }
      
      if (this.password !== this.confirmPassword) {
        this.showToastMsg('两次输入的密码不一致');
        return false;
      }
      
      if (this.email && !this.isValidEmail(this.email)) {
        this.showToastMsg('请输入正确的邮箱格式');
        return false;
      }
      
      if (!this.agreeTerms) {
        this.showToastMsg('请先同意用户协议');
        return false;
      }
      
      return true;
    },
    
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    
    toggleAgreement() {
      this.agreeTerms = !this.agreeTerms;
    },
    
    goToLogin() {
      this.$router.push('/login');
    },
    
    showToastMsg(msg) {
      this.$toast(msg);
    }
  }
};
</script>

<style scoped lang="css" src="./assets/register-style.css" />
